import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { Duration } from "luxon";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getTimeSpentOnAppDaily } from "_controllers/officer";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import exportExcel from "utils/excelGenerate";
import { PageHeader, SectionCard, EmptyState } from "_shared/ui";

const TimeSpent = () => {
  const { SAP_ID } = useParams();

  const [Values, setValues] = useState({
    selectStartDate: '',
    selectEndDate: '',
  });

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [onDate, setOnDate] = useState();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [csvData, setCsvData] = useState([]);

  const fileName = `${SAP_ID}-time-spent`;

  useEffect(async () => {
    const startDate = moment().startOf("month").format("YYYY-MM-DD");

    const endDate = moment().endOf("month").format("YYYY-MM-DD");

    const plan = await getTimeSpentOnAppDaily({
      SAP_ID,
      onDate,
      startDate,
      endDate,
    });
    setData(plan?.data);
    setCsvData(plan?.data)
    setLoading(true);
  }, [message]);

  const { selectStartDate, selectEndDate } = Values

  const handleChange = (e) => {
    setValues({ ...Values, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const plan = await getTimeSpentOnAppDaily({
      SAP_ID,
      startDate: selectStartDate,
      endDate: selectEndDate,
    });
    setData(plan?.data);
    setCsvData(plan?.data)
    setLoading(true);
  }

  const generateExcel = async (e) => {
    e.preventDefault()
    exportExcel(csvData.map(x => ({
      'SAP ID': x._id.SAP_ID,
      'Date': x._id.date,
      'Time Spent(mins)': (x.total_count * 0.0166667).toFixed(0)
    })), fileName)
  }

  return (
    <>
      <PageHeader
        title="Time Spent"
        subtitle={`Daily time spent on the app${SAP_ID ? ` — ${SAP_ID}` : ""}`}
      />

      <SectionCard sx={{ mb: 3 }}>
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                type="date"
                label="Start Date"
                fullWidth
                size="small"
                onChange={handleChange}
                value={selectStartDate}
                name="selectStartDate"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                type="date"
                label="End Date"
                fullWidth
                size="small"
                onChange={handleChange}
                value={selectEndDate}
                name="selectEndDate"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<FilterAltOutlinedIcon />}
                  onClick={handleSubmit}
                >
                  Filter
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<DownloadIcon />}
                  onClick={generateExcel}
                >
                  Download
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </SectionCard>

      {loading ? (
        <SectionCard title="Daily Time Spent" disablePadding>
          {data?.length > 0 ? (
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">SAP_ID</TableCell>
                    <TableCell align="center">Date</TableCell>
                    <TableCell align="center">Time Spent (min)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.map((d) => (
                    <TableRow key={d._id}>
                      <TableCell align="left">
                        {d?._id?.SAP_ID}
                      </TableCell>
                      <TableCell align="center">{d?.date}</TableCell>
                      <TableCell align="center">
                        {Duration.fromMillis(d?.total_count * 1000).as('minutes').toFixed(0)} min
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <EmptyState
              icon={ScheduleOutlinedIcon}
              title="No time spent data"
              description="Time spent unavailable for today."
            />
          )}
        </SectionCard>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress />
        </Box>
      )}
    </>
  );
};

export default TimeSpent;
